// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bo-b";
export var colorBlue = "_bo-8";
export var colorDot = "_bo-0";
export var colorDotLarge = "_bo-2";
export var colorDotSmall = "_bo-1";
export var colorGreen = "_bo-7";
export var colorGrey = "_bo-3";
export var colorOrange = "_bo-5";
export var colorPink = "_bo-a";
export var colorPurple = "_bo-9";
export var colorRed = "_bo-4";
export var colorYellow = "_bo-6";